// 公開 viewer 的訪客識別（AM-185）
// 閱覽報表改由後端的閱覽紀錄（online_visit_log）統計，新訪客 / 回訪訪客由後端依 visitor id 判斷。
// - visitor id：存在 localStorage，同一個瀏覽器長期沿用。key 與格式和 arviewer 共用同一份規格：
//   key 為 istaging_visitor_id，值為 UUID v4 字串。
// - visit id：每次整頁載入產生一個 UUID v4，這次載入內固定不變；
//   送給 API 與 GA page_view 的是同一個值，方便兩邊的紀錄對得起來。
export const VISITOR_ID_KEY = "istaging_visitor_id";

const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuidV4 = (value) => typeof value === "string" && UUID_V4.test(value);

const toHex = (byte) => byte.toString(16).padStart(2, "0");

// 優先用 crypto.randomUUID（只在 secure context 可用）；沒有就用 getRandomValues 自行組，
// 兩者都沒有（極舊瀏覽器）才退回 Math.random。
export function generateUuidV4(cryptoApi = window.crypto) {
  if (typeof cryptoApi?.randomUUID === "function") return cryptoApi.randomUUID();

  const bytes = new Uint8Array(16);
  if (typeof cryptoApi?.getRandomValues === "function") {
    cryptoApi.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  // RFC 4122：第 7 個 byte 的高 4 bits 為版本 4，第 9 個 byte 的高 2 bits 為 variant 10
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, toHex).join("");
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join("-");
}

function getLocalStorage() {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

// 讀取已存的 visitor id；不存在或格式不對 → 產生新的並寫回。
// storage 無法使用（被封鎖、讀寫丟錯）時照樣回傳一個 id，只是不會保存到下次載入。
export function resolveVisitorId(storage, generate = generateUuidV4) {
  let stored = null;
  try {
    stored = storage ? storage.getItem(VISITOR_ID_KEY) : null;
  } catch {
    stored = null;
  }
  if (isUuidV4(stored)) return stored;

  const id = generate();
  try {
    if (storage) storage.setItem(VISITOR_ID_KEY, id);
  } catch {
    // storage 滿了或被封鎖：這次載入只用記憶體中的 id
  }
  return id;
}

// 這次整頁載入的值，第一次取用時才決定，之後都回傳同一個
let currentVisitorId = null;
let currentVisitId = null;

// 只有公開 viewer 會呼叫，後台頁面不會寫入 localStorage
export function getVisitorId() {
  if (!currentVisitorId) currentVisitorId = resolveVisitorId(getLocalStorage());
  return currentVisitorId;
}

export function getVisitId() {
  if (!currentVisitId) currentVisitId = generateUuidV4();
  return currentVisitId;
}
